import React, { useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Form, Formik } from 'formik';
import DialogContent from '@mui/material/DialogContent';
import TextField from '../formik/TextField';
import { Button, MenuItem, Stack } from '@mui/material';
import OutlinedButton from '../button/OutlinedButton';
import StudentAutocomplete from '../formik/StudentAutocomplete';
import TeacherUtil from '../../utils/TeacherUtil';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '../formik/Select';

const EditTeacherDialog = ({ teacher, open, onClose }) => {
  const initialValues = useMemo(
    () => ({
      firstName: teacher.firstName,
      lastName: teacher.lastName,
      type: teacher.type,
      userId: teacher.userId,
      students: (teacher.students?.split(',') || []).map(id => parseInt(id)),
    }),
    [teacher],
  );

  const onSubmit = (values, { setSubmitting }) => {
    TeacherUtil.updateTeacher(teacher.id, values)
      .then(() => {
        onClose(true);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Docent bewerken</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ isValid, isSubmitting }) => (
            <Form>
              <Stack spacing={3}>
                <Stack direction="row" spacing={1}>
                  <TextField label="Voornaam*" name="firstName" />
                  <TextField label="Achternaam*" name="lastName" />
                </Stack>
                <Select label="Rol" name="type">
                  <MenuItem value="">Medewerker</MenuItem>
                  <MenuItem value="institute">Beheerder</MenuItem>
                </Select>
                <StudentAutocomplete name="students" initialValues={initialValues.students} />
                <Stack direction="row" justifyContent="end" spacing={1}>
                  <OutlinedButton onClick={() => onClose(false)}>Annuleren</OutlinedButton>
                  <Button variant="contained" type="submit" disabled={!isValid || isSubmitting}>
                    Opslaan
                    {isSubmitting && <CircularProgress size={14} sx={{ ml: 1 }} />}
                  </Button>
                </Stack>
              </Stack>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditTeacherDialog;
